import styled from "styled-components"

import { ApiTypes, UITypes } from "types"
import type { TableActionButtonGroup } from "types/table/tableActionButton"
import { ReactComponent as IconEye } from "assets/svg/icon-eye.svg"
import { ReactComponent as IconFile } from "assets/svg/icon-file.svg"

import { isMobileDevice } from "utils/deviceDetection"
import { Pagination } from "components/common/Pagination"
import TableWrapper from "components/table/TableWrapper"

import type { IntelligenceReportDrawerRow } from "./IntelligenceReportDrawer"

const TableSection = styled.div`
  overflow: auto;
  flex: 1;

  .rowNavButtonsContainer {
    justify-content: center;
    align-items: center;
  }

  .tableActionsWrapper {
    background: linear-gradient(90deg, rgba(248, 250, 252, 0.7) 0%, #f1f5f9 100%);
    justify-content: flex-start;
    align-items: center;
    gap: 8px;
  }

  .fullReportAction {
    padding: 0 !important;
    width: auto !important;
    display: flex;
    align-items: center;

    span {
      height: auto;
      padding: 0 !important;
      width: auto !important;
    }

    span:hover,
    &:hover {
      background-color: transparent !important;
      opacity: 0.9 !important;
    }
  }
`

const FullReportText = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: #2db2c8;
  white-space: nowrap;
`

interface Props {
  data: UITypes.TableBodyRow[]
  isLoading: boolean
  meta?: ApiTypes.Model.Pagination
  onViewReport: (item: IntelligenceReportDrawerRow) => void
  headerCells: UITypes.TableHeaderCell[]
}

export const IntelligenceReportsTable = ({ data, isLoading, meta, onViewReport, headerCells }: Props) => {
  const isMobile = isMobileDevice()

  const getRowActions = (rowData: UITypes.TableBodyRow): TableActionButtonGroup => {
    const item = rowData.rowSettings?.item as IntelligenceReportDrawerRow | undefined

    return {
      className: "",
      actionButtons: [
        {
          icon: <IconEye />,
          tooltip: "View report",
          tooltipPosition: "top",
          handler: () => {
            if (item) onViewReport(item)
          },
        },
        {
          icon: isMobile ? <IconFile /> : <FullReportText>Full Report</FullReportText>,
          tooltip: "Full Report",
          tooltipPosition: "top",
          className: isMobile ? "" : "fullReportAction",
          handler: () => {
            if (!item) return
            window.open(`/intelligence-reports/${item.report_id}/full`, "_blank")
          },
        },
      ],
    }
  }

  return (
    <>
      <TableSection>
        <TableWrapper
          headerCells={headerCells}
          data={data}
          isLoading={isLoading}
          columnsLoaded={true}
          fitContainer={true}
          getRowActions={getRowActions}
          isMobileDevice={isMobile}
          skippedTags={["priority"]}
        />
      </TableSection>
      {meta !== undefined && <Pagination meta={meta} />}
    </>
  )
}
